import { Contract, CreateContractPolicy } from "../dtos";
import { BaseEndpoint } from "./BaseEndpoint";
import { WithCreate } from "./mixins/WithCreate";
import { WithDelete } from "./mixins/WithDelete";
import { WithGet } from "./mixins/WithGet";
import { WithUpdate } from "./mixins/WithUpdate";

export class Endpoint extends BaseEndpoint("contracts") {
  getContractsByCompany(companyId: string): Promise<Contract[]> {
    return this.request(`company/${companyId}`);
  }
  deleteFromPolicy(id: string): Promise<void> {
    return this.request(`policy/${id}`, {
      method: "DELETE",
    });
  }
}

//@TODO: improve typing
const withGetOne = WithGet<typeof Endpoint, Contract>(Endpoint);

const withCreate = WithCreate<typeof withGetOne, Contract, CreateContractPolicy>(withGetOne);

const withUpdate = WithUpdate<typeof withCreate, Contract, Partial<CreateContractPolicy>>(withCreate);

export const ContractEndpoint = WithDelete(withUpdate);
